<template>
  <div class="q-pa-md">
    <q-table
      :data="servicios"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      @row-click="openURL"
      :loading="isLoading"
      data-cy="servicios-table"
    >
      <template v-slot:body-cell-state="props">
        <q-td>
          <q-toggle
            color="primary"
            v-model="props.row.visible"
            label="Visible en Catálogo"
            @input="changeVisibility(props.row.visible, props.row)"
          />
        </q-td>
      </template>
      <template v-slot:body-cell-name="props">
        <q-td>
          <q-img
            style="border-radius: 50%; margin-right: 20px"
            width="45px"
            height="45px"
            :src="setImage(props.row.resources)"
          />
          {{ props.value }}
        </q-td>
      </template>
      <template v-slot:body-cell-tematica="props">
        <q-td>
          <div v-bind:key="key" v-for="(tematica, key) in props.value">
            <q-chip outline class="text-weight-bold" color="grey-8">
              {{ tematica }}
            </q-chip>
            <br />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-assignedApp="props">
        <q-td>
          {{ props.value ? props.value : "-" }}
        </q-td>
      </template>
      <template v-slot:body-cell-exceptions="props">
        <q-td>
          {{ props.value ? "Sí" : "No" }}
        </q-td>
      </template>
    </q-table>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import { QTable, QTd, QChip, QToggle, QImg } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  components: {
    QTable,
    QTd,
    QImg,
    QChip,
    QToggle
  },
  mixins: [Message, Validation, Loading, Resources],
  props: {
    arrayServicios: Array,
    isLoading: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data: function () {
    return {
      pagination: {
        sortBy: 'order',
        rowsPerPage: 20
      },
      servicios: [],
      columns: [
        {
          name: 'state',
          required: true,
          label: 'Estado',
          align: 'left',
          field: 'visible'
        },
        {
          name: 'name',
          required: true,
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'order',
          required: true,
          label: 'Orden',
          align: 'left',
          field: 'displayOrder',
          sortable: true
        },
        {
          name: 'assignedApp',
          required: true,
          align: 'left',
          label: 'Aplicación asignada',
          field: 'aplicacionAsignada',
          sortable: true
        },
        {
          name: 'tematica',
          required: true,
          align: 'left',
          label: 'Temáticas',
          field: 'tematicas'
        },
        {
          name: 'exceptions',
          required: true,
          align: 'left',
          label: 'Excepciones',
          field: 'excepciones'
        }
      ]
    };
  },
  methods: {
    async changeVisibility (value, row) {
      let servicio = {
        name: row.name,
        visible: value,
        description: row.description,
        displayOrder: row.displayOrder
      };

      let request = {
        controller: `/Servicio/${row.id}`,
        filter: {},
        body: servicio
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then(() => {
          this.showMessage('Se ha modificado la visibilidad del servicio.');
        })
        .catch(err => {
          this.showError(err);
        });
    },
    setImage (itemResources) {
      const imagen = this.searchResource(itemResources, 'Imagen');
      const urlFile =
        imagen !== null ? imagen.url : this.getDefaultResource('Imagen');

      return urlFile;
    },
    openURL (e, row) {
      this.$router.push({
        name: 'form_service',
        params: { idServ: row.id }
      });
    }
  },
  watch: {
    arrayServicios: {
      handler: function () {
        this.servicios = this.arrayServicios;
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
  .q-table__card {
    border-radius: 12px;
  }
</style>
